import { ApiVault } from '../openapi';

export function isVaultMatch(query: string, vault: ApiVault) {
  // Search by vault ID
  if (vault.id === query) return true;

  // Search by currency
  if (vault.balance.currency?.toLowerCase().includes(query)) return true;

  return false;
}
